// ============================================================
// DONNEES ISSUES DE LA MATRICE DE COMPATIBILITE
// (Matrice_compatibilite_formes_options.xlsx - version validee)
// ============================================================
const MODELS = [
  { id:'carre-205-int',      forme:'Carré',     taille:'205',      poele:'Intégré',   points:4,  group:'poele_int', powers:['35'], poelePoint:3 },
  { id:'octo-240x240-int',   forme:'Octogonal', taille:'240/240',  poele:'Intégré',   points:8,  group:'poele_int', powers:['35'], poelePoint:7 },
  { id:'octo-240x240-ext',   forme:'Octogonal', taille:'240/240',  poele:'Extérieur', points:8,  group:'Octogonal', powers:['35','40','45'] },
  { id:'ovale-200x240-ext',  forme:'Ovale',      taille:'200/240',  poele:'Extérieur', points:12, group:'Ovale',     powers:['35','40','45'], small:false },
  { id:'ovale-165x115-ext',  forme:'Ovale',      taille:'165/115',  poele:'Extérieur', points:8,  group:'Ovale',     powers:['35','40','45'], small:true, poeleAttachOptions:[1,5] },
  { id:'rond-200-int',       forme:'Rond',       taille:'200',      poele:'Intégré',   points:12, group:'poele_int', powers:['35'], poelePoint:6 },
  { id:'rond-225-int',       forme:'Rond',       taille:'225',      poele:'Intégré',   points:12, group:'poele_int', powers:['35'], poelePoint:6 },
  { id:'octo-180x180-ext',   forme:'Octogonal', taille:'180/180',  poele:'Extérieur', points:8,  group:'Octogonal', powers:['35','40','45'] },
  { id:'octo-240x180-int',   forme:'Octogonal', taille:'240/180',  poele:'Intégré',   points:8,  group:'poele_int', powers:['35'], poelePoint:6 },
  { id:'octo-240x180-ext',   forme:'Octogonal', taille:'240/180',  poele:'Extérieur', points:8,  group:'Octogonal', powers:['35','40','45'] },
  { id:'octo-280x210-ext',   forme:'Octogonal', taille:'280/210',  poele:'Extérieur', points:8,  group:'Octogonal', powers:['35','40','45'] },
  { id:'rond-175-ext',       forme:'Rond',       taille:'175',      poele:'Extérieur', points:12, group:'Rond',      powers:['35','40','45'] },
  { id:'rond-190-ext',       forme:'Rond',       taille:'190',      poele:'Extérieur', points:12, group:'Rond',      powers:['35','40','45'] },
  { id:'rond-200-ext',       forme:'Rond',       taille:'200',      poele:'Extérieur', points:12, group:'Rond',      powers:['35','40','45'] },
  { id:'rond-220-ext',       forme:'Rond',       taille:'220',      poele:'Extérieur', points:12, group:'Rond',      powers:['35','40','45'] },
  { id:'carre-205-ext',      forme:'Carré',      taille:'205',      poele:'Extérieur', points:4,  group:'Carre',     powers:['35','40','45'] },
];

function modelLabel(m){
  return `${m.forme} ${m.taille} - poêle ${m.poele.toLowerCase()}`;
}

const POWER_RULE = {
  '35': { label:'35 kW', letters:['B'], choice:false, note:"Ouverture fixe à l'avant (repère B). Aucun choix possible.",
    photo:'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Vignette_PoA_le_35Kw_bl.webp?v=1775924399' },
  '40': { label:'40 kW', letters:['B'], choice:false, note:"Ouverture fixe à l'avant (repère B). Aucun choix possible.",
    photo:'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Vignette_PoA_le40.webp?v=1775924415' },
  '45': { label:'45 kW', letters:['A','C'], choice:true, note:"Choix du côté d'ouverture / sens de raccordement : A ou C selon le côté souhaité (pas d'ouverture en façade sur cette puissance).",
    photo:'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Vignette_PoA_le45.webp?v=1775924419' },
};

function habillageOptions(model){
  const base = [
    { value:'lasure',   label:'Pin du nord lasuré',   colors:['Marron clair','Noir'] },
    { value:'thermo',   label:'Bois thermo-traité',    colors:['Marron','Noir'] },
    { value:'pvc',       label:'PVC',                   colors:['Gris'] },
  ];
  const has41 = (model.group === 'Rond') || (model.forme === 'Ovale' && model.small === true);
  if(has41){
    base.push({ value:'41mm', label:'Habillage épais 41mm avec cerclage inox (structurel)', colors:['Marron clair','Noir'] });
  }
  return base;
}

function cerclageDecoAvailable(model){
  if(model.forme === 'Rond') return true;
  if(model.forme === 'Ovale' && model.small === true) return true;
  return false;
}

const OPTIONS = [
  {
    id:'coudes90', label:"Coudes 90° pour poêle", type:'checkbox',
    available: (m)=> m.poele === 'Extérieur',
    needsPower: (p)=> p==='35' || p==='40',
    note:"Uniquement compatible avec un poêle 35 ou 40 kW (le 45 kW permet déjà de choisir le côté nativement)."
  },
  {
    id:'rallonge', label:"Rallonge conduit de poêle (+1m)", type:'checkbox',
    available: ()=> true,
    note:"Nécessite une fixation de maintien supplémentaire."
  },
  {
    id:'longerons', label:"Longerons plastiques", type:'checkbox',
    available: ()=> true,
    note:"Recommandé sur sol non drainant (dalle carrelée, etc.)."
  },
  {
    id:'escalier', label:"Amélioration escalier - modèle Luxe", type:'checkbox',
    available: ()=> true,
    note: null
  },
  {
    id:'led', label:"Éclairage LED", type:'qty', choices:[0,1,2,4],
    available: ()=> true,
    note:"Choix de 1, 2 ou 4 LED selon la taille du bain."
  },
  {
    id:'thermometre', label:"Thermomètre intégré", type:'checkbox',
    available: ()=> true,
    requiresOptionQty:{ id:'led', min:1 },
    note:"Alimenté par l'éclairage LED : nécessite qu'au moins 1 LED soit sélectionnée."
  },
  {
    id:'bulles', label:"Système de bulles", type:'qty', choices:[0,8,16],
    unit:'buses',
    available: ()=> true,
    incompatibleWith:{ field:'habillage', value:'41mm' },
    note:"Choix entre 8 ou 16 buses. Incompatible avec l'habillage 41mm structurel (moteur inaccessible)."
  },
  {
    id:'porteverre', label:"Porte-verre", type:'qty', choices:[0,1,2,3],
    available: ()=> true,
    note:"Généralement 1 unité, jusqu'à 3 possibles."
  },
  {
    id:'appuitete', label:"Appui-tête", type:'qty', choices:[0,1,2,3,4,5,6,7,8,9,10],
    available: ()=> true,
    note:"De 1 à 10 unités."
  },
  {
    id:'pediluve', label:"Pédiluve", type:'checkbox',
    available: ()=> true,
    note:"Recommandé en été pour une installation sur herbe."
  },
];

const FILTRATION_CHOICES = [
  { value:'skimmer', label:'Skimmer flottant' },
  { value:'systeme', label:'Système de filtration + buses de raccordement' },
  { value:'buses',   label:'Buses de raccordement seules' },
  { value:'caisson', label:'Caisson de filtration assorti au bain' },
];

// ============================================================
// IMAGES (fournies par Julien)
// ============================================================
const COULEUR_COQUE_IMAGES = {
  'Blanc': 'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Capture_d_ecran_2025-01-25_170409.png?v=1739299372',
  'Gris':  'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Capture_d_ecran_2025-01-25_170350.png?v=1739299372',
  'Bleu':  'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Capture_d_ecran_2025-01-25_170402.png?v=1739299364',
};

const HABILLAGE_IMAGES = {
  lasure: {
    'Marron clair': 'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Vignette_Lasure_marron.webp?v=1774464376',
    'Noir':         'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Vignette_Lasure_noir.webp?v=1774464376',
  },
  thermo: {
    'Marron': 'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Vignette_Thermo_traite_marron.webp?v=1774464376',
    'Noir':   'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Vignette_Thermo_traite_noir.webp?v=1774464376',
  },
  pvc: {
    'Gris': 'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Vignette_PVC.webp?v=1774464377',
  },
  '41mm': {
    'Marron clair': 'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Vignette_Lasure_marron_41mm_cercle_inox.webp?v=1774464376',
    'Noir':         'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Vignette_Lasure_noir_41mm_cercle_inox.webp?v=1774464376',
  },
};

const FILTRATION_IMAGES = {
  systeme: 'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/vignette_Systeme_de_filtration.webp?v=1774382687',
  caisson: 'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Caisson_de_filtration.webp?v=1774464698',
  skimmer: 'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/vignette_Systeme_de_fitration_de_surface_e18f1333-6cc5-43dc-a2b7-9405b4968b75.webp?v=1775926032',
};

// ============================================================
// INFO-BULLES (icone "i" cliquable/survolable, texte + image optionnelle)
// Une entree peut etre un objet fixe {text, image}, ou une fonction qui
// retourne {text, image} en fonction de l'etat actuel (pour les bulles
// dont l'image change selon la couleur/le materiau selectionne).
// -> A COMPLETER si besoin : le texte est volontairement minimal, dis-moi
//    si tu veux des explications plus detaillees pour certaines options.
// ============================================================
const INFO_CONTENT = {
  gamme:            { text:"Essentiel : coque non isolée, couverture bâche PVC incluse. Premium : coque isolée + couverture isolée incluse.", image:null },
  couleurCoque:      () => ({ text:`Coque ${state.couleur.toLowerCase()}.`, image: COULEUR_COQUE_IMAGES[state.couleur] || null }),
  puissancePoele:   { text:"Plus la puissance est élevée, plus la montée en température est rapide. Le repère d'ouverture du poêle dépend de la puissance choisie.", image:null },
  habillage:         () => {
    const opt = habillageOptions(currentModel()).find(h=>h.value===state.habillage);
    return {
      text: opt ? opt.label + '.' : '',
      image: (HABILLAGE_IMAGES[state.habillage] || {})[state.habillageColor] || null,
    };
  },
  habillageCouleur:  () => ({
    text:`Couleur : ${state.habillageColor}.`,
    image: (HABILLAGE_IMAGES[state.habillage] || {})[state.habillageColor] || null,
  }),
  cerclageDeco:     { text:"Cerclage inox posé en surface, purement esthétique (contrairement à l'habillage 41mm qui est structurel).", image:null },
  filtration:       { text:"Plusieurs systèmes de filtration peuvent être combinés selon vos besoins.", image:null },
  coudes90:         { text:"Uniquement compatible avec un poêle 35 ou 40 kW (le 45 kW permet déjà de choisir le côté nativement).", image:'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Vignette_coudes_90.webp?v=1784142698' },
  rallonge:         { text:"Nécessite une fixation de maintien supplémentaire.", image:'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/produitrallongeconduitsf.png?v=1739632160' },
  longerons:        { text:"Recommandé sur sol non drainant (dalle carrelée, etc.).", image:'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Vignette_Lambourde_PVC.webp?v=1775926308' },
  escalier:         { text:"Modèle Luxe. La forme (arrondie ou droite) suit automatiquement la forme du bain.", image:'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Vignette_Escaliers_rond_et_carre_luxe.webp?v=1774378397' },
  led:              { text:"Choix de 1, 2 ou 4 LED selon la taille du bain.", image:null },
  thermometre:      { text:"Alimenté par l'éclairage LED : nécessite qu'au moins 1 LED soit sélectionnée.", image:'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Vignette_ThermomA_tre_digital.webp?v=1775926431' },
  bulles:           { text:"Choix entre 8 ou 16 buses. Incompatible avec l'habillage 41mm structurel (moteur inaccessible).", image:null },
  porteverre:       { text:"Généralement 1 unité, jusqu'à 3 possibles.", image:'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Vignette_Tablette_repose_verre.webp?v=1774382534' },
  appuitete:        { text:"De 1 à 10 unités.", image:'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/vignette_Appui-tete.webp?v=1784142698' },
  pediluve:         { text:"Recommandé en été pour une installation sur herbe.", image:'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Vignette_Pediluve.webp?v=1774381852' },
};

function resolveInfoContent(key){
  const entry = INFO_CONTENT[key];
  if(!entry) return null;
  return typeof entry === 'function' ? entry() : entry;
}

// ============================================================
// INFO-BULLES ETAPE 4 (Implantation) - conseils de positionnement
// pour les emplacements a choisir sur le schema (filtration, boutons,
// thermometre, vidange).
// ============================================================
const IMPLANTATION_INFO = {
  'Entrée (escalier)': {
    text:"L'escalier n'est pas fixé au bain : vous pourrez donc le repositionner par la suite selon vos envies. Cette information nous permet simplement de vérifier la cohérence de la configuration finale (emplacement des options, du poêle, etc.). À noter : la plaque de la marque est généralement installée au niveau de l'entrée.",
    image:'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Escalier_Luxe_Rond_Thermo-traite.webp?v=1784369576'
  },
  'Filtration': {
    text:"Le positionnement des piquages de filtration est un point important à anticiper. Il faut prévoir non seulement l'espace nécessaire pour le cache de filtration, mais aussi le recul suffisant autour de celui-ci pour pouvoir le déplacer lors des interventions d'entretien sur le système de filtration. Les piquages sont de taille standard pour toute pompe de diamètre 32mm.",
    image:'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Detail_piquage_filtration.webp?v=1784365444'
  },
  'Boutons LED / bulles / Thermomètre': {
    text:"Ces 3 éléments sont regroupés au même emplacement pour plus de simplicité. Le thermomètre étant alimenté par l'éclairage LED, l'allumage de la lumière active automatiquement le thermomètre, évitant qu'il reste allumé en permanence et inutilement. L'idéal est de positionner ce groupe entre l'entrée et le poêle : ce sont les deux zones où la lecture de la température est la plus utile, que ce soit pour vérifier la température avant d'entrer ou pour surveiller la chauffe près du poêle.",
    image:'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Position_des_boutons.webp?v=1784365445'
  },
  'Vidange': {
    text:"Deux moyens de vidange possibles. Le bouchon de fond (bonde livrée d'origine) : son utilisation est fortement recommandée en période hivernale, car elle évite que l'eau stagnant dans le tuyau PVC (Ø32mm) ne gèle et n'endommage l'installation. La vanne 1/4 de tour : pour une utilisation hors gel, positionnable à l'endroit de votre choix, prolongeable via un raccord fileté femelle 26/34 pour plus de flexibilité.",
    image:'https://cdn.shopify.com/s/files/1/0902/0188/2888/files/Vidange.webp?v=1784365444'
  },
};

function implantationIcon(elLabel){
  const content = IMPLANTATION_INFO[elLabel];
  if(!content) return null;

  const wrap = document.createElement('span');
  wrap.className = 'info-icon';
  wrap.textContent = 'i';
  wrap.tabIndex = 0;
  wrap.setAttribute('role', 'button');
  wrap.setAttribute('aria-label', "Plus d'informations");

  const panel = document.createElement('span');
  panel.className = 'info-tooltip';
  if(content.image){
    const imgWrap = document.createElement('span');
    imgWrap.className = 'img-square';
    const img = document.createElement('img');
    img.src = content.image;
    img.alt = '';
    imgWrap.appendChild(img);
    panel.appendChild(imgWrap);
  }
  if(content.text){
    const txt = document.createElement('span');
    txt.textContent = content.text;
    panel.appendChild(txt);
  }
  wrap.appendChild(panel);

  wrap.addEventListener('click', (e) => {
    e.stopPropagation();
    const wasOpen = wrap.classList.contains('open');
    document.querySelectorAll('.atb-configurator .info-icon.open').forEach(el => el.classList.remove('open'));
    if(!wasOpen) wrap.classList.add('open');
  });
  wrap.addEventListener('keydown', (e) => {
    if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); wrap.click(); }
  });
  return wrap;
}

function infoIcon(key){
  const content = resolveInfoContent(key);
  if(!content) return null;

  const wrap = document.createElement('span');
  wrap.className = 'info-icon';
  wrap.textContent = 'i';
  wrap.tabIndex = 0;
  wrap.setAttribute('role', 'button');
  wrap.setAttribute('aria-label', "Plus d'informations");

  const panel = document.createElement('span');
  panel.className = 'info-tooltip';
  if(content.image){
    const imgWrap = document.createElement('span');
    imgWrap.className = 'img-square';
    const img = document.createElement('img');
    img.src = content.image;
    img.alt = '';
    imgWrap.appendChild(img);
    panel.appendChild(imgWrap);
  }
  if(content.text){
    const txt = document.createElement('span');
    txt.textContent = content.text;
    panel.appendChild(txt);
  }
  wrap.appendChild(panel);

  wrap.addEventListener('click', (e) => {
    e.stopPropagation();
    const wasOpen = wrap.classList.contains('open');
    document.querySelectorAll('.atb-configurator .info-icon.open').forEach(el => el.classList.remove('open'));
    if(!wasOpen) wrap.classList.add('open');
  });
  wrap.addEventListener('keydown', (e) => {
    if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); wrap.click(); }
  });
  return wrap;
}
document.addEventListener('click', () => {
  document.querySelectorAll('.atb-configurator .info-icon.open').forEach(el => el.classList.remove('open'));
});

// Ajoute/rafraichit une icone info a cote d'un <label> statique (steps 1 et 2).
// On retire l'ancienne a chaque appel pour que le contenu dynamique (image selon
// la couleur/le materiau choisi) reste a jour.
function attachStaticInfoIcon(labelSelector, key){
  const label = document.querySelector(labelSelector);
  if(!label) return;
  const existing = label.querySelector('.info-icon');
  if(existing) existing.remove();
  const icon = infoIcon(key);
  if(icon) label.appendChild(icon);
}

function deliveryInfo(model){
  const parts = String(model.taille).split('/').map(s => parseFloat(s));
  const minDim = Math.min(...parts.filter(n => !isNaN(n)));
  const isSmall = minDim <= 200;
  return {
    minDim,
    type: isSmall ? 'messagerie' : 'semi-remorque',
    text: isSmall
      ? "Livraison à domicile, jusqu'au portail (sous réserve d'accès pour le camion). Réalisée par une entreprise de messagerie avec un camion équipé d'un hayon et d'un transpalette : le déchargement est assuré par le chauffeur. L'installation n'est pas comprise et peut faire l'objet d'un devis complémentaire."
      : "Livraison à domicile, jusqu'au portail (sous réserve d'accès pour le camion). Réalisée par un transporteur avec un camion de type semi-remorque, non équipé de hayon : un moyen de déchargement doit être prévu le jour de la livraison, soit au moins 6 à 7 personnes costaudes, soit un engin à fourches (tracteur, manuscopique, gerbeur, Manitou...). L'installation n'est pas comprise et peut faire l'objet d'un devis complémentaire.",
  };
}

function emplacementsFor(model){
  const base = ['Entrée (escalier)', 'Filtration', 'Boutons LED / bulles / Thermomètre'];
  if(model.poele === 'Extérieur'){
    base.push('Vidange');
    // Pas de ligne generique "Poêle" ici si un selecteur dedie existe deja
    // ("Emplacement du poêle", pour les modeles a poeleAttachOptions) : elle ferait doublon
    // et, contrairement au selecteur dedie, ne repositionne pas le poele sur le schema.
    if(!model.poeleAttachOptions) base.push('Poêle');
  }
  return base;
}

// ============================================================
// ETAT
// ============================================================
const STEPS = ['modele','poele','options','implantation','client','recap'];
const STEP_LABELS = {
  modele:'1. Modèle', poele:'2. Poêle', options:'3. Options',
  implantation:'4. Implantation', client:'5. Client', recap:'6. Récapitulatif'
};
let currentStep = 'modele';

const state = {
  modelId: MODELS[0].id,
  gamme: 'Essentiel',
  couleur: 'Blanc',
  power: null,
  habillage: 'lasure',
  habillageColor: 'Marron clair',
  cerclageDeco: false,
  optQty: { led:0, bulles:0, porteverre:0, appuitete:0 },
  optBool: { coudes90:false, rallonge:false, longerons:false, escalier:false, thermometre:false, pediluve:false },
  filtration: [],
  assign: {},
  poeleRepere: null,
  poeleAttach: null,
  client: { nom:'', tel:'', adresse:'' },
};

function currentModel(){ return MODELS.find(m => m.id === state.modelId); }

// ============================================================
// NAVIGATION
// ============================================================
function renderStepsNav(){
  const nav = document.getElementById('stepsNav');
  nav.innerHTML = '';
  STEPS.forEach(s => {
    const b = document.createElement('button');
    b.textContent = STEP_LABELS[s];
    if(s === currentStep) b.classList.add('active');
    b.onclick = () => goTo(s);
    nav.appendChild(b);
  });
}

function goTo(step){
  currentStep = step;
  document.querySelectorAll('section.panel').forEach(p => p.classList.remove('active'));
  document.getElementById('panel-' + step).classList.add('active');
  renderStepsNav();
  if(step === 'poele') renderPoeleStep();
  if(step === 'options') renderOptionsStep();
  if(step === 'implantation') renderImplantationStep();
  if(step === 'recap') renderRecap();
  window.scrollTo({top:0, behavior:'smooth'});
}

// ============================================================
// STEP 1 : MODELE
// ============================================================
function renderModelSelect(){
  const sel = document.getElementById('selModel');
  sel.innerHTML = '';
  MODELS.forEach(m => {
    const opt = document.createElement('option');
    opt.value = m.id;
    opt.textContent = modelLabel(m);
    sel.appendChild(opt);
  });
  sel.value = state.modelId;
  sel.addEventListener('change', () => {
    state.modelId = sel.value;
    const m = currentModel();
    if(!m.powers.includes(state.power)) state.power = null;
    const validHab = habillageOptions(m).map(h=>h.value);
    if(!validHab.includes(state.habillage)) state.habillage = validHab[0];
    if(!cerclageDecoAvailable(m)) state.cerclageDeco = false;
    state.assign = {};
    state.poeleRepere = null;
    state.poeleAttach = null;
  });

  document.getElementById('selGamme').value = state.gamme;
  document.getElementById('selGamme').addEventListener('change', (e) => {
    state.gamme = e.target.value;
    renderGammeInfo();
  });
  document.getElementById('selCouleur').value = state.couleur;
  document.getElementById('selCouleur').addEventListener('change', (e) => {
    state.couleur = e.target.value;
    attachStaticInfoIcon('label[for="selCouleur"]', 'couleurCoque');
  });

  renderGammeInfo();
  attachStaticInfoIcon('label[for="selGamme"]', 'gamme');
  attachStaticInfoIcon('label[for="selCouleur"]', 'couleurCoque');
}

function renderGammeInfo(){
  const box = document.getElementById('gammeInfo');
  if(state.gamme === 'Premium'){
    box.textContent = "Gamme Premium : isolation de la coque incluse + couverture isolée incluse.";
  } else {
    box.textContent = "Gamme Essentiel : coque non isolée, couverture bâche PVC incluse.";
  }
}

// ============================================================
// STEP 2 : POELE
// ============================================================
function renderPoeleStep(){
  const m = currentModel();
  const sel = document.getElementById('selPower');
  sel.innerHTML = '';
  m.powers.forEach(p => {
    const opt = document.createElement('option');
    opt.value = p; opt.textContent = POWER_RULE[p].label;
    sel.appendChild(opt);
  });
  if(!state.power || !m.powers.includes(state.power)) state.power = m.powers[0];
  sel.value = state.power;
  sel.onchange = () => { state.power = sel.value; state.poeleRepere = null; renderPowerInfo(); };
  renderPowerInfo();
  attachStaticInfoIcon('label[for="selPower"]', 'puissancePoele');
}
function renderPowerInfo(){
  const rule = POWER_RULE[state.power];
  document.getElementById('powerInfo').textContent = rule.note;
  document.getElementById('poelePhoto').src = rule.photo;
}

// ============================================================
// STEP 3 : OPTIONS
// ============================================================
function qtyRow(opt){
  const val = state.optQty[opt.id] || 0;
  const wrap = document.createElement('div');
  wrap.className = 'qty-control';
  const minus = document.createElement('button');
  minus.type='button'; minus.textContent='−';
  const span = document.createElement('span');
  span.textContent = val + (opt.unit ? ' ' + opt.unit : '');
  const plus = document.createElement('button');
  plus.type='button'; plus.textContent='+';

  function idx(){ return opt.choices.indexOf(state.optQty[opt.id] || 0); }
  minus.onclick = () => {
    const i = idx();
    if(i > 0){ state.optQty[opt.id] = opt.choices[i-1]; renderOptionsStep(); }
  };
  plus.onclick = () => {
    const i = idx();
    if(i < opt.choices.length - 1){ state.optQty[opt.id] = opt.choices[i+1]; renderOptionsStep(); }
  };
  wrap.appendChild(minus); wrap.appendChild(span); wrap.appendChild(plus);
  return wrap;
}

function renderOptionsStep(){
  const m = currentModel();
  const list = document.getElementById('optionsList');
  list.innerHTML = '';

  // --- Habillage (choix unique) ---
  const habCard = document.createElement('div');
  habCard.className = 'option-card';
  const habTitle = document.createElement('div');
  habTitle.className = 'option-title'; habTitle.textContent = "Type d'habillage";
  habTitle.appendChild(infoIcon('habillage'));
  habCard.appendChild(habTitle);
  const habSelect = document.createElement('select');
  habillageOptions(m).forEach(h => {
    const o = document.createElement('option'); o.value=h.value; o.textContent=h.label;
    habSelect.appendChild(o);
  });
  if(!habillageOptions(m).some(h=>h.value===state.habillage)) state.habillage = habillageOptions(m)[0].value;
  habSelect.value = state.habillage;
  habSelect.onchange = () => {
    state.habillage = habSelect.value;
    const cur = habillageOptions(m).find(h=>h.value===state.habillage);
    if(cur && !cur.colors.includes(state.habillageColor)) state.habillageColor = cur.colors[0];
    renderOptionsStep();
  };
  habCard.appendChild(habSelect);

  // Couleur d'habillage (dependante du materiau)
  const curHab = habillageOptions(m).find(h=>h.value===state.habillage);
  if(curHab && curHab.colors.length > 1){
    const colorLabel = document.createElement('label');
    colorLabel.textContent = "Couleur de l'habillage";
    colorLabel.style.marginTop = '10px';
    colorLabel.appendChild(infoIcon('habillageCouleur'));
    habCard.appendChild(colorLabel);
    const colorSelect = document.createElement('select');
    curHab.colors.forEach(col => {
      const o = document.createElement('option'); o.value=col; o.textContent=col;
      colorSelect.appendChild(o);
    });
    if(!curHab.colors.includes(state.habillageColor)) state.habillageColor = curHab.colors[0];
    colorSelect.value = state.habillageColor;
    colorSelect.onchange = () => { state.habillageColor = colorSelect.value; renderOptionsStep(); };
    habCard.appendChild(colorSelect);
  } else if(curHab){
    state.habillageColor = curHab.colors[0];
    const note = document.createElement('div'); note.className = 'option-note';
    note.textContent = `Couleur : ${curHab.colors[0]} (unique pour ce matériau)`;
    habCard.appendChild(note);
  }
  if(state.habillage === '41mm'){
    const w = document.createElement('div'); w.className='warn-box';
    w.textContent = "Habillage 41mm structurel sélectionné : incompatible avec le système de bulles (moteur inaccessible).";
    habCard.appendChild(w);
  }
  list.appendChild(habCard);

  // --- Cerclage decoratif ---
  if(cerclageDecoAvailable(m) && state.habillage !== '41mm'){
    const card = document.createElement('div'); card.className='option-card';
    const top = document.createElement('div'); top.className='option-top';
    const titleWrap = document.createElement('label'); titleWrap.className='option-title';
    const cb = document.createElement('input'); cb.type='checkbox'; cb.checked = state.cerclageDeco;
    cb.onchange = () => { state.cerclageDeco = cb.checked; };
    titleWrap.appendChild(cb);
    titleWrap.appendChild(document.createTextNode(' Cerclage inox décoratif'));
    titleWrap.appendChild(infoIcon('cerclageDeco'));
    top.appendChild(titleWrap);
    card.appendChild(top);
    const note = document.createElement('div'); note.className='option-note';
    note.textContent = "Version décorative posée sur habillage fin (non structurelle).";
    card.appendChild(note);
    list.appendChild(card);
  }

  // --- Options generiques ---
  OPTIONS.forEach(opt => {
    const isAvailable = opt.available(m);
    const powerOk = opt.needsPower ? opt.needsPower(state.power) : true;
    let disabled = !isAvailable || !powerOk;

    const card = document.createElement('div');
    card.className = 'option-card' + (disabled ? ' disabled' : '');

    const top = document.createElement('div'); top.className = 'option-top';
    const titleWrap = document.createElement('label'); titleWrap.className = 'option-title';

    if(opt.type === 'checkbox'){
      const cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.checked = !!state.optBool[opt.id];
      cb.disabled = disabled;

      if(opt.requiresOptionQty){
        const dep = state.optQty[opt.requiresOptionQty.id] || 0;
        if(dep < opt.requiresOptionQty.min){
          cb.disabled = true;
          if(state.optBool[opt.id]) state.optBool[opt.id] = false;
        }
      }
      cb.onchange = () => { state.optBool[opt.id] = cb.checked; renderOptionsStep(); };
      titleWrap.appendChild(cb);
      titleWrap.appendChild(document.createTextNode(' ' + opt.label));
      const ic1 = infoIcon(opt.id); if(ic1) titleWrap.appendChild(ic1);
      top.appendChild(titleWrap);
    } else if(opt.type === 'qty'){
      titleWrap.appendChild(document.createTextNode(opt.label));
      const ic2 = infoIcon(opt.id); if(ic2) titleWrap.appendChild(ic2);
      top.appendChild(titleWrap);
      if(!disabled) top.appendChild(qtyRow(opt));
    }

    if(disabled){
      const tag = document.createElement('span'); tag.className='option-unavailable';
      tag.textContent = !isAvailable ? 'Non disponible sur ce modèle' : 'Non compatible avec la puissance choisie';
      top.appendChild(tag);
    }

    card.appendChild(top);

    if(opt.incompatibleWith){
      const f = opt.incompatibleWith;
      if(state[f.field] === f.value && !disabled){
        disabled = true;
        state.optQty[opt.id] = 0;
        const tag = document.createElement('span'); tag.className='option-unavailable';
        tag.textContent = 'Incompatible avec habillage 41mm sélectionné';
        top.appendChild(tag);
        card.classList.add('disabled');
      }
    }

    let noteText = opt.note;
    if(opt.id === 'escalier'){
      const arrondie = (m.forme === 'Rond' || m.forme === 'Ovale');
      noteText = `Forme ${arrondie ? 'arrondie' : 'droite'} (liée à la forme du bain).`;
    }
    if(noteText){
      const note = document.createElement('div'); note.className = 'option-note';
      note.textContent = noteText;
      card.appendChild(note);
    }

    list.appendChild(card);
  });

  // --- Filtration (choix multiple) ---
  const filCard = document.createElement('div'); filCard.className='option-card';
  const filTitle = document.createElement('div'); filTitle.className='option-title'; filTitle.textContent='Filtration';
  filTitle.appendChild(infoIcon('filtration'));
  filCard.appendChild(filTitle);
  const filNote = document.createElement('div'); filNote.className='option-note';
  filNote.textContent = 'Plusieurs systèmes peuvent être combinés.';
  filCard.appendChild(filNote);
  const filGroup = document.createElement('div'); filGroup.className='radio-group';
  FILTRATION_CHOICES.forEach(f => {
    const lab = document.createElement('label');
    const cb = document.createElement('input');
    cb.type='checkbox'; cb.value=f.value;
    cb.checked = state.filtration.includes(f.value);
    cb.onchange = () => {
      if(cb.checked){ if(!state.filtration.includes(f.value)) state.filtration.push(f.value); }
      else { state.filtration = state.filtration.filter(v => v !== f.value); }
    };
    lab.appendChild(cb);
    lab.appendChild(document.createTextNode(' ' + f.label));
    if(FILTRATION_IMAGES[f.value]){
      const wrap = document.createElement('span');
      wrap.className = 'info-icon';
      wrap.textContent = 'i';
      wrap.tabIndex = 0;
      wrap.setAttribute('role', 'button');
      wrap.setAttribute('aria-label', "Plus d'informations");
      const panel = document.createElement('span');
      panel.className = 'info-tooltip';
      const imgWrap = document.createElement('span');
      imgWrap.className = 'img-square';
      const img = document.createElement('img');
      img.src = FILTRATION_IMAGES[f.value];
      img.alt = '';
      imgWrap.appendChild(img);
      panel.appendChild(imgWrap);
      const txt = document.createElement('span'); txt.textContent = f.label + '.';
      panel.appendChild(txt);
      wrap.appendChild(panel);
      wrap.addEventListener('click', (e) => {
        e.stopPropagation();
        const wasOpen = wrap.classList.contains('open');
        document.querySelectorAll('.atb-configurator .info-icon.open').forEach(el => el.classList.remove('open'));
        if(!wasOpen) wrap.classList.add('open');
      });
      wrap.addEventListener('keydown', (e) => {
        if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); wrap.click(); }
      });
      lab.appendChild(wrap);
    }
    filGroup.appendChild(lab);
  });
  filCard.appendChild(filGroup);
  list.appendChild(filCard);
}

// ============================================================
// STEP 4 : IMPLANTATION
// ============================================================
function octagonPoints(cx, cy, r){
  const pts = [];
  for(let i=0;i<8;i++){
    const angle = (Math.PI*2*i/8) - Math.PI/2 + Math.PI/8;
    pts.push(`${(cx+r*Math.cos(angle)).toFixed(1)},${(cy+r*Math.sin(angle)).toFixed(1)}`);
  }
  return pts;
}

function buildRectOctagon(cx, cy, halfW, halfH){
  const L = (2*halfH) / (1 + Math.SQRT2);
  const a = L / Math.SQRT2;
  const topHalf = halfW - a;
  const half = L / 2;
  const verts = [
    [cx-topHalf, cy-halfH], [cx+topHalf, cy-halfH],
    [cx+halfW,   cy-half],  [cx+halfW,   cy+half],
    [cx+topHalf, cy+halfH], [cx-topHalf, cy+halfH],
    [cx-halfW,   cy+half],  [cx-halfW,   cy-half],
  ];
  const mids = verts.map((v, i) => {
    const n = verts[(i+1) % verts.length];
    return { x:(v[0]+n[0])/2, y:(v[1]+n[1])/2 };
  });
  return { verts, mids };
}

function perimeterPoint(model, n, cx, cy, rx, ry, innerR){
  const idx = n - 1;
  if(model.forme === 'Octogonal'){
    const ratio = octagonAspect(model.taille);
    let halfW = innerR, halfH = innerR;
    if(ratio >= 1){ halfW = innerR; halfH = innerR/ratio; } else { halfH = innerR; halfW = innerR*ratio; }
    return buildRectOctagon(cx, cy, halfW, halfH).mids[idx];
  }
  if(model.forme === 'Rond' || model.forme === 'Ovale'){
    if(model.forme === 'Ovale' && model.points === 8){
      return stadiumPointSegmented(cx, cy, rx, ry, n);
    }
    return stadiumPoint(cx, cy, rx, ry, n, model.points);
  }
  const angle = (Math.PI*2*idx/model.points) - Math.PI/2;
  return { x: cx + rx*Math.cos(angle), y: cy + ry*Math.sin(angle) };
}

function stadiumPointSegmented(cx, cy, rx, ry, n){
  const s = Math.max(rx - ry, 0);
  const layout = [
    () => ({ x: cx, y: cy-ry }),
    () => capPoint(cx+s, cy, ry, -60),
    () => capPoint(cx+s, cy, ry, 0),
    () => capPoint(cx+s, cy, ry, 60),
    () => ({ x: cx, y: cy+ry }),
    () => capPoint(cx-s, cy, ry, 120),
    () => capPoint(cx-s, cy, ry, 180),
    () => capPoint(cx-s, cy, ry, 240),
  ];
  return layout[(n-1) % 8]();
}
function capPoint(capCx, capCy, r, deg){
  const a = deg * Math.PI / 180;
  return { x: capCx + r*Math.cos(a), y: capCy + r*Math.sin(a) };
}

function stadiumPoint(cx, cy, rx, ry, n, total){
  const s = Math.max(rx - ry, 0);
  const arcLen = Math.PI * ry;
  const perim = 4*s + 2*arcLen;
  let d = (n - 1) / total * perim;

  if(d < s){ return { x: cx + d, y: cy-ry }; }
  d -= s;
  if(d < arcLen){ const a = -Math.PI/2 + (d/arcLen)*Math.PI; return { x: cx+s+ry*Math.cos(a), y: cy+ry*Math.sin(a) }; }
  d -= arcLen;
  if(d < 2*s){ return { x: cx+s-d, y: cy+ry }; }
  d -= 2*s;
  if(d < arcLen){ const a = Math.PI/2 + (d/arcLen)*Math.PI; return { x: cx-s+ry*Math.cos(a), y: cy+ry*Math.sin(a) }; }
  d -= arcLen;
  return { x: cx-s+d, y: cy-ry };
}

function stadiumPath(cx, cy, rx, ry){
  const s = Math.max(rx - ry, 0);
  if(s === 0) return `<circle cx="${cx}" cy="${cy}" r="${ry}" fill="none" stroke="#B7B7A8" stroke-width="3"/>`;
  return `<path d="M ${cx-s} ${cy-ry} L ${cx+s} ${cy-ry} A ${ry} ${ry} 0 0 1 ${cx+s} ${cy+ry} L ${cx-s} ${cy+ry} A ${ry} ${ry} 0 0 1 ${cx-s} ${cy-ry} Z" fill="none" stroke="#B7B7A8" stroke-width="3"/>`;
}

function octagonAspect(taille){
  const parts = String(taille).split('/').map(s => parseFloat(s));
  if(parts.length === 2 && parts[0] && parts[1]) return parts[0] / parts[1];
  return 1;
}

function drawPiquages(x, y, dirX, dirY, count){
  const perpX = -dirY, perpY = dirX;
  const spacing = 7;
  const offsetStart = -((count-1)*spacing)/2;
  let svg = '';
  for(let i=0;i<count;i++){
    const off = offsetStart + i*spacing;
    const sx = x + perpX*off, sy = y + perpY*off;
    const ex = sx + dirX*11, ey = sy + dirY*11;
    svg += `<line x1="${sx.toFixed(1)}" y1="${sy.toFixed(1)}" x2="${ex.toFixed(1)}" y2="${ey.toFixed(1)}" stroke="#7A5310" stroke-width="2.5" stroke-linecap="round"/>`;
  }
  return svg;
}

function buildSchemaMarkup(model){
  const cx = 150, cy = 130;
  const R = 95;
  let rx = R, ry = R;
  if(model.forme === 'Rond'){
    rx = R; ry = R;
  } else if(model.forme === 'Ovale'){
    const parts = String(model.taille).split('/').map(s => parseFloat(s));
    const big = Math.max(parts[0], parts[1]);
    const small = Math.min(parts[0], parts[1]);
    const ratio = big / small;
    rx = R; ry = R/ratio;
  }
  const innerRx = rx - 22, innerRy = ry - 22;
  const octInnerR = R - 22;
  const pointInnerR = (model.forme === 'Carré' || model.forme === 'Octogonal') ? octInnerR : innerRx;

  let points = '';
  for(let n=1;n<=model.points;n++){
    const p = perimeterPoint(model, n, cx, cy, rx, ry, pointInnerR);
    points += `<circle cx="${p.x.toFixed(1)}" cy="${p.y.toFixed(1)}" r="11" fill="#E4E2D0" stroke="#5A661B" stroke-width="1.5"/>`;
    points += `<text x="${p.x.toFixed(1)}" y="${(p.y+4).toFixed(1)}" text-anchor="middle" font-size="11" fill="#5A661B" font-weight="600">${n}</text>`;
  }

  let shape = '';
  if(model.forme === 'Rond' || model.forme === 'Ovale'){
    shape = stadiumPath(cx, cy, innerRx, innerRy);
  } else if(model.forme === 'Carré'){
    const half = octInnerR * 0.8;
    shape = `<rect x="${cx-half}" y="${cy-half}" width="${half*2}" height="${half*2}" rx="6" fill="none" stroke="#B7B7A8" stroke-width="3"/>`;
  } else if(model.forme === 'Octogonal'){
    const ratio = octagonAspect(model.taille);
    let halfW = octInnerR, halfH = octInnerR;
    if(ratio >= 1){ halfW = octInnerR; halfH = octInnerR/ratio; } else { halfH = octInnerR; halfW = octInnerR*ratio; }
    const { verts } = buildRectOctagon(cx, cy, halfW, halfH);
    shape = `<polygon points="${verts.map(v=>v.join(',')).join(' ')}" fill="none" stroke="#B7B7A8" stroke-width="3"/>`;
  }

  let poele = '';
  if(model.poele === 'Extérieur'){
    let edge, dir;
    if(model.poeleAttachOptions){
      const attachN = state.poeleAttach || model.poeleAttachOptions[0];
      const p = perimeterPoint(model, attachN, cx, cy, rx, ry, pointInnerR);
      const ddx = p.x - cx, ddy = p.y - cy, dist = Math.sqrt(ddx*ddx + ddy*ddy) || 1;
      edge = p; dir = { x: ddx/dist, y: ddy/dist };
    } else {
      edge = { x: cx - rx - 2, y: cy + 75 };
      dir = { x: -1, y: 0 };
    }
    const psize = 30, gap = 4;
    const boxCx = edge.x + dir.x*(psize/2+gap), boxCy = edge.y + dir.y*(psize/2+gap);
    const px = boxCx - psize/2, py = boxCy - psize/2;
    const innerFace = { x: boxCx - dir.x*(psize/2), y: boxCy - dir.y*(psize/2) };
    const outerFace  = { x: boxCx + dir.x*(psize/2), y: boxCy + dir.y*(psize/2) };
    const perp = { x: -dir.y, y: dir.x };

    poele = `<rect x="${px.toFixed(1)}" y="${py.toFixed(1)}" width="${psize}" height="${psize}" rx="4" fill="#EFD9C6" stroke="#B9791E" stroke-width="1.5"/>
      <text x="${boxCx.toFixed(1)}" y="${(boxCy+3).toFixed(1)}" text-anchor="middle" font-size="8.5" fill="#7A5310">poêle</text>`;

    const piquageCount = state.power === '45' ? 3 : 2;
    poele += drawPiquages(innerFace.x, innerFace.y, -dir.x, -dir.y, piquageCount);

    const rule = POWER_RULE[state.power];
    const letterPos = {
      A: { x: boxCx + perp.x*(psize/2+16), y: boxCy + perp.y*(psize/2+16) },
      B: { x: outerFace.x + dir.x*16, y: outerFace.y + dir.y*16 },
      C: { x: boxCx - perp.x*(psize/2+16), y: boxCy - perp.y*(psize/2+16) },
    };
    ['A','B','C'].forEach(l => {
      const active = rule.letters.includes(l);
      if(!active) return;
      const pos = letterPos[l];
      const isSel = state.poeleRepere === l;
      const fill = isSel ? '#5A661B' : '#F3C97A';
      const textFill = isSel ? '#fff' : '#7A5310';
      poele += `<line x1="${boxCx.toFixed(1)}" y1="${boxCy.toFixed(1)}" x2="${pos.x.toFixed(1)}" y2="${pos.y.toFixed(1)}" stroke="#B7B7A8" stroke-width="1" stroke-dasharray="2,2"/>`;
      poele += `<circle cx="${pos.x.toFixed(1)}" cy="${pos.y.toFixed(1)}" r="10" fill="${fill}" stroke="#B9791E" stroke-width="1.5"/>`;
      poele += `<text x="${pos.x.toFixed(1)}" y="${(pos.y+3.5).toFixed(1)}" text-anchor="middle" font-size="10" font-weight="700" fill="${textFill}">${l}</text>`;
    });
  } else if(model.poelePoint){
    const edge = perimeterPoint(model, model.poelePoint, cx, cy, rx, ry, pointInnerR);
    const poeleR = pointInnerR * 0.34;
    const dx = edge.x - cx, dy = edge.y - cy;
    const dist = Math.sqrt(dx*dx + dy*dy) || 1;
    const poeleCx = cx + (dist - poeleR*0.9) * (dx/dist);
    const poeleCy = cy + (dist - poeleR*0.9) * (dy/dist);
    poele = `<polygon points="${octagonPoints(poeleCx, poeleCy, poeleR).join(' ')}" fill="#EFD9C6" stroke="#B9791E" stroke-width="1.5"/>
      <text x="${poeleCx}" y="${poeleCy+3.5}" text-anchor="middle" font-size="8.5" fill="#7A5310">poêle</text>
      <circle cx="${edge.x}" cy="${edge.y}" r="4" fill="none" stroke="#7A5310" stroke-width="1.3"/>`;
  } else {
    const poeleR = pointInnerR * 0.32;
    const poeleCx = cx, poeleCy = cy + innerRy * 0.35;
    poele = `<polygon points="${octagonPoints(poeleCx, poeleCy, poeleR).join(' ')}" fill="#EFD9C6" stroke="#B9791E" stroke-width="1.5"/>
      <text x="${poeleCx}" y="${poeleCy+3.5}" text-anchor="middle" font-size="8.5" fill="#7A5310">poêle</text>
      <line x1="${poeleCx}" y1="${poeleCy-poeleR}" x2="${poeleCx-18}" y2="${poeleCy-poeleR-22}" stroke="#B7B7A8" stroke-width="1" stroke-dasharray="2,2"/>
      <circle cx="${poeleCx-18}" cy="${poeleCy-poeleR-22}" r="4" fill="none" stroke="#7A5310" stroke-width="1.3"/>
      <text x="${poeleCx-18}" y="${poeleCy-poeleR-28}" text-anchor="middle" font-size="7.5" fill="#7A5310">vidange</text>`;
  }

  return `<title>Schéma d'implantation</title>${shape}${points}${poele}`;
}

function renderSchemaSvg(model){
  const svg = document.getElementById('schemaSvg');
  svg.innerHTML = buildSchemaMarkup(model);
}

function renderImplantationStep(){
  const m = currentModel();
  renderSchemaSvg(m);
  document.getElementById('schemaLegend').textContent = m.poele === 'Extérieur'
    ? "Les petits traits marron sur le poêle représentent les piquages de raccordement hydraulique."
    : "Poêle intégré : aucun piquage apparent (raccordement interne à la coque).";
  const list = document.getElementById('assignList');
  list.innerHTML = '';

  if(m.poele === 'Intégré'){
    const note = document.createElement('div'); note.className = 'warn-box';
    note.style.marginBottom = '14px';
    note.textContent = "Poêle intégré : la vidange se trouve au niveau du poêle (fixe, non modifiable).";
    list.appendChild(note);
  }

  if(m.poeleAttachOptions){
    if(!m.poeleAttachOptions.includes(Number(state.poeleAttach))) state.poeleAttach = m.poeleAttachOptions[0];
    const row = document.createElement('div'); row.className = 'assign-row';
    const label = document.createElement('label'); label.textContent = 'Emplacement du poêle';
    const sel = document.createElement('select');
    m.poeleAttachOptions.forEach(n => {
      const o = document.createElement('option'); o.value=n; o.textContent='Repère ' + n;
      sel.appendChild(o);
    });
    sel.value = state.poeleAttach;
    sel.onchange = () => { state.poeleAttach = Number(sel.value); renderImplantationStep(); };
    row.appendChild(label); row.appendChild(sel);
    list.appendChild(row);
  }

  // Repere occupe par le poele, quel que soit le mecanisme de selection :
  // - poelePoint : poele integre, repere fixe
  // - state.poeleAttach : petit ovale, plusieurs emplacements possibles (choix ci-dessus)
  // - state.assign['Poêle'] : poele exterieur standard, choix libre parmi les reperes
  // Ce repere ne peut jamais etre partage avec un autre element (filtration, boutons, etc.).
  const poeleFixedPoint = m.poelePoint || (m.poeleAttachOptions ? state.poeleAttach : null);
  const poeleManualPoint = (!poeleFixedPoint && m.poele === 'Extérieur' && state.assign['Poêle'])
    ? Number(state.assign['Poêle']) : null;
  const reservedPoint = poeleFixedPoint || poeleManualPoint;

  const elements = emplacementsFor(m);
  elements.forEach(el => {
    const row = document.createElement('div'); row.className = 'assign-row';
    const label = document.createElement('label'); label.textContent = el;
    const icon = implantationIcon(el);
    if(icon) label.appendChild(icon);
    const sel = document.createElement('select');
    const empty = document.createElement('option'); empty.value=''; empty.textContent='—';
    sel.appendChild(empty);
    for(let i=1;i<=m.points;i++){
      // Le repere du poele est exclu pour tous les autres elements - jamais pour "Poêle"
      // lui-meme, sinon sa propre valeur selectionnee disparaitrait de la liste.
      if(reservedPoint === i && el !== 'Poêle') continue;
      const o = document.createElement('option'); o.value=i; o.textContent='Repère ' + i;
      sel.appendChild(o);
    }
    if(el !== 'Poêle' && state.assign[el] == reservedPoint) state.assign[el] = '';
    sel.value = state.assign[el] || '';
    sel.onchange = () => {
      state.assign[el] = sel.value;
      // Si c'est le poele qu'on vient de repositionner, on rafraichit pour mettre a jour
      // les exclusions chez les autres elements (libere l'ancien repere, bloque le nouveau).
      if(el === 'Poêle') renderImplantationStep();
    };
    row.appendChild(label); row.appendChild(sel);
    list.appendChild(row);
  });

  if(m.poele === 'Extérieur'){
    const rule = POWER_RULE[state.power];
    const row = document.createElement('div'); row.className = 'assign-row';
    const label = document.createElement('label'); label.textContent = 'Repère vitre poêle';
    if(rule.choice){
      const sel = document.createElement('select');
      rule.letters.forEach(l => {
        const o = document.createElement('option'); o.value=l; o.textContent=l;
        sel.appendChild(o);
      });
      sel.value = state.poeleRepere || rule.letters[0];
      state.poeleRepere = sel.value;
      sel.onchange = () => { state.poeleRepere = sel.value; renderSchemaSvg(m); };
      row.appendChild(label); row.appendChild(sel);
    } else {
      state.poeleRepere = 'B';
      const span = document.createElement('div'); span.style.fontSize='13px'; span.style.color='#6B6E64';
      span.textContent = 'B (fixe, aucun choix possible avec cette puissance)';
      row.appendChild(label); row.appendChild(span);
    }
    list.appendChild(row);
  }
}

// ============================================================
// STEP 6 : RECAP
// ============================================================
function renderRecap(){
  const m = currentModel();
  const c = document.getElementById('recapContent');
  const rows = (pairs) => pairs.map(([k,v]) => `<tr><td>${k}</td><td>${v || '<span class="empty">—</span>'}</td></tr>`).join('');

  const optLines = [];
  if(state.optBool.coudes90) optLines.push('Coudes 90° pour poêle');
  if(state.optBool.rallonge) optLines.push('Rallonge conduit de poêle (+1m)');
  if(state.optBool.longerons) optLines.push('Longerons plastiques');
  if(state.optBool.escalier) optLines.push('Amélioration escalier - modèle Luxe');
  if(state.optBool.pediluve) optLines.push('Pédiluve');
  if(state.optQty.led > 0) optLines.push(`Éclairage LED x${state.optQty.led}`);
  if(state.optBool.thermometre) optLines.push('Thermomètre intégré');
  if(state.optQty.bulles > 0) optLines.push(`Système de bulles (${state.optQty.bulles} buses)`);
  if(state.optQty.porteverre > 0) optLines.push(`Porte-verre x${state.optQty.porteverre}`);
  if(state.optQty.appuitete > 0) optLines.push(`Appui-tête x${state.optQty.appuitete}`);
  if(state.cerclageDeco) optLines.push('Cerclage inox décoratif');

  const habLabel = (habillageOptions(m).find(h=>h.value===state.habillage) || {}).label || '—';
  const filLabels = state.filtration.map(v => (FILTRATION_CHOICES.find(f=>f.value===v)||{}).label).filter(Boolean);

  const assignLines = Object.entries(state.assign).filter(([,v])=>v).map(([k,v]) => `${k} : repère ${v}`);
  if(state.poeleRepere) assignLines.push(`Poêle (vitre) : repère ${state.poeleRepere}`);
  if(m.poeleAttachOptions) assignLines.push(`Poêle (emplacement) : repère ${state.poeleAttach}`);
  if(m.poelePoint) assignLines.push(`Poêle (emplacement) : repère ${m.poelePoint} (fixe)`);
  if(m.poele === 'Intégré') assignLines.push('Vidange : au niveau du poêle (fixe)');

  c.innerHTML = `
    <h3>Modèle</h3>
    <table>${rows([
      ['Forme', m.forme],
      ['Taille', m.taille],
      ['Position du poêle', m.poele],
      ['Gamme', state.gamme],
      ['Couleur de coque', state.couleur],
      ['Puissance poêle', POWER_RULE[state.power].label],
    ])}</table>

    <h3>Habillage</h3>
    <table>${rows([
      ["Type d'habillage", habLabel],
      ['Couleur', state.habillageColor],
      ['Cerclage décoratif', state.cerclageDeco ? 'Oui' : 'Non'],
    ])}</table>

    <h3>Options et accessoires</h3>
    <table>${optLines.length ? optLines.map(l=>`<tr><td colspan="2">• ${l}</td></tr>`).join('') : '<tr><td colspan="2"><span class="empty">Aucune option sélectionnée</span></td></tr>'}</table>

    <h3>Filtration</h3>
    <table>${filLabels.length ? filLabels.map(l=>`<tr><td colspan="2">• ${l}</td></tr>`).join('') : '<tr><td colspan="2"><span class="empty">Aucun système sélectionné</span></td></tr>'}</table>

    <h3>Schéma d'implantation</h3>
    <svg viewBox="-25 0 305 260" style="width:100%; max-width:340px; display:block; margin:0 auto 10px;">${buildSchemaMarkup(m)}</svg>
    <p style="font-size:12px; color:#6B6E64; text-align:center; margin:0 0 8px;">Ce schéma reprend les repères numérotés utilisés dans le tableau "Emplacements" ci-dessous.</p>

    <h3>Emplacements</h3>
    <table>${assignLines.length ? assignLines.map(l=>`<tr><td colspan="2">${l}</td></tr>`).join('') : '<tr><td colspan="2"><span class="empty">Aucun emplacement renseigné</span></td></tr>'}</table>

    <h3>Client</h3>
    <table>${rows([
      ['Nom', document.getElementById('cNom').value],
      ['Numéro de devis', document.getElementById('cDevis').value],
      ['Téléphone', document.getElementById('cTel').value],
      ['Adresse de livraison', document.getElementById('cAdr').value],
    ])}</table>

    <h3>Conditions de livraison</h3>
    <p style="font-size:13px; color:#6B6E64; margin:0 0 6px;">${deliveryInfo(m).text}</p>

    <h3>Délai</h3>
    <p style="font-size:13px; color:#6B6E64;">Comptez entre 2 et 3 semaines de fabrication une fois le dossier complet (validation des options, règlement, informations nécessaires).</p>
  `;
}

// Construit un nom de fichier lisible : Fiche de Personnalisation - Nom - Forme - Taille - Position du poêle
// (retombe sur un nom generique si le champ "Nom" n'a pas ete rempli)
function buildRecapTitle(){
  const m = currentModel();
  const nom = (document.getElementById('cNom').value || '').trim();
  const parts = ['Fiche de Personnalisation'];
  if(nom) parts.push(nom);
  parts.push(m.forme, m.taille, 'poêle ' + m.poele.toLowerCase());
  return parts.join(' - ');
}

function printRecap(){
  const content = document.getElementById('recapContent').innerHTML;
  const title = buildRecapTitle();
  const w = window.open('', '_blank', 'width=900,height=1100');
  if(!w){
    alert("Le navigateur a bloqué l'ouverture de la fenêtre d'impression. Autorisez les pop-ups pour ce site puis réessayez.");
    return;
  }
  w.document.open();
  w.document.write(`<!DOCTYPE html><html lang="fr"><head><meta charset="UTF-8"><title>${title}</title>
  <style>
    body{font-family:'Helvetica Neue',Arial,sans-serif; color:#1a1a18; margin:0; padding:32px; background:#fff;}
    h1{font-size:18px; color:#5A661B; margin:0 0 18px;}
    h3{color:#5A661B; font-size:15px; border-bottom:1px solid #E4E2D0; padding-bottom:6px; margin:20px 0 10px;}
    h3:first-of-type{margin-top:0;}
    table{width:100%; border-collapse:collapse; font-size:13.5px; margin-bottom:4px;}
    table td{padding:5px 4px; border-bottom:1px solid #EFEBDD; vertical-align:top;}
    table td:first-child{color:#6B6E64; width:45%;}
    .empty{color:#6B6E64; font-style:italic;}
    @media print{ body{padding:12mm;} }
  </style>
  </head><body>
  <h1>${title}</h1>
  ${content}
  </body></html>`);
  w.document.close();
  w.focus();
  setTimeout(() => { try{ w.print(); }catch(e){} }, 400);
}

// ============================================================
// INIT
// ============================================================
renderStepsNav();
renderModelSelect();
goTo('modele');